
import { useEffect } from 'react';
import { Grid, TextField, MenuItem } from '@mui/material';
import { usePlanillassStore, useUsuariosStore, useVehiculoStore } from '../../../../store';
import { DatePicker, LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import dayjs from 'dayjs';




export const FormInformacionUser = ({ onCahnge }) => {


    const {startListSegunRol, startListTodosClinetes, startListTodosOperarios, clientes, usuarios, operarios} = useUsuariosStore();
    const { formValues, updateFormValue } = usePlanillassStore();
    const { startListVehiculoConductor, vehiculos } = useVehiculoStore();


    useEffect(() => {
        startListSegunRol('CONDUCTOR');
        startListTodosClinetes('CLIENTE');
        startListTodosOperarios('GALPONERO');
    }, []);


    useEffect(() => {
        if (formValues.conductor && vehiculos.length === 0) {
            handleChangeVehiculo(formValues.conductor);
        }
    }, []);

    
    const handleChangeHora = (name, value) => {
        if (!value || !dayjs(value).isValid()) return;
        updateFormValue({ name, value: dayjs(value).toISOString() });
    };


    const handleChangeFecha = (value) => {
        if (!value || !dayjs(value).isValid()) return;
        const withTime = dayjs(value).set('hour', dayjs().hour()).set('minute', dayjs().minute()).set('second', dayjs().second());
        updateFormValue({ name: 'fecha', value: withTime.toISOString() });
    };


    const handleChangeVehiculo = async (value) => {
        if (!value) return;
        updateFormValue({ name: 'conductor', value });
        await startListVehiculoConductor(value);
    };



    return (

        <>
        <Grid item xs={12}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    label="Fecha"
                    value={formValues.fecha || null}
                    onChange={ handleChangeFecha }
                    renderInput={ (params) => <TextField {...params} fullWidth size='small' /> }
                />
            </LocalizationProvider>
        </Grid>

    
        <Grid item xs={12} sm={6} md={4}>
            <TextField required
                size="small"
                select
                label="Seleccione Conductor"
                fullWidth
                name='conductor'
                value={usuarios.some((u) => u.id === formValues.conductor) ? formValues.conductor : ''}
                onChange={(event) => handleChangeVehiculo(event.target.value)}
            >
                <MenuItem value=''> Seleccione Conductor</MenuItem>
                {usuarios?.map( e => (
                    <MenuItem key={ e.id } value={ e.id } >{ e.nombre }</MenuItem>
                ))}
            </TextField>
        </Grid>


        <Grid item xs={12} sm={6} md={4}>
            <TextField required
                size="small"
                select
                label='Vehiculo'
                type='Text'
                placeholder='Vehiculo'
                name='vehiculo'
                fullWidth
                value={vehiculos.some((u) => u.id === formValues.vehiculo) ? formValues.vehiculo : ''}
                onChange={ onCahnge }
            >
                <MenuItem value=''> Seleccione Vehiculo</MenuItem>
                {vehiculos?.map( e => (
                    <MenuItem key={ e.id } value={ e.id } >{ e.placa }</MenuItem>
                ))}
            </TextField>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
            <TextField required
                size="small"
                select
                label="Seleccione Cliente"
                fullWidth
                name='cliente'
                value={clientes.some((u) => u.id === formValues.cliente) ? formValues.cliente : ''}
                onChange={ onCahnge }
            >
                <MenuItem value=''> Seleccione Cliente</MenuItem>
                {clientes?.map( e => (
                    <MenuItem key={ e.id } value={ e.id } >{ e.nombre }</MenuItem>
                ))}
            </TextField>
        </Grid> 


        <Grid item xs={12} sm={6} md={4}>
            <TextField required
                size="small"
                select
                label="Seleccione Pesador"
                fullWidth
                name='pesador'
                value={operarios.some((u) => u.id === formValues.pesador) ? formValues.pesador : ''}
                onChange={ onCahnge }
            >
                <MenuItem value=''> Seleccione Pesador</MenuItem>
                {operarios?.map( e => (
                    <MenuItem key={ e.id } value={ e.id } >{ e.nombre }</MenuItem>
                ))}
            </TextField>
        </Grid> 

        <Grid item xs={12} sm={6} md={4}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                    label="Hora Inicio"
                    name='start'
                    value={formValues.horaInicio ? dayjs(formValues.horaInicio) : null}
                    onChange={(value) => handleChangeHora('horaInicio', value)}
                    renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                />
            </LocalizationProvider>
        </Grid>
        
        <Grid item xs={12} sm={6} md={4}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                    label="Hora Final"
                    name='end'
                    value={formValues.horaFinal ? dayjs(formValues.horaFinal) : null}
                    onChange={(value) => handleChangeHora('horaFinal', value)}
                    renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                />
            </LocalizationProvider>
        </Grid> 
        </>
    )
}

